import React from 'react';

import { MASK_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxCustomFilter } from '../components/checkbox-custom-filter/CheckboxCustomFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { useFilterCount } from '../hooks';

export const MasksCheckboxesPopover = ({ onCountChange = undefined }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const selectedMasks = useWatch({ name: 'masks' });
  const filterCount = Array.isArray(selectedMasks) && selectedMasks.length > 0 ? 1 : 0;
  useFilterCount('masks', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="masksFilter"
      triggerValue={t('mask')}
    >
      <CheckboxCustomFilter
        control={control}
        isMulti
        name="masks"
        options={MASK_OPTIONS.raw}
      />
    </CustomFilterPopover>
  );
};
